// export const BRANDING_GET_ENDPOINT = '/api/v1/branding';
export const BRANDING_GET_ENDPOINT = '/api/User/get-navigation-menu-Info';
export const BRANDING_ACTION_GET_ENDPOINT = '/api/v1/branding/action';
export const LAST_UPDATE_NEW_MEMBER =
  '/api/MemberProfile/member/update-last-get-new-members';
export const LAST_UPDATE_NEW_DAMS = '/api/dam/update-last-get-new-dams';
export const LAST_UPDATE_NEW_PRODUCT = '/api/pim/update-last-get-new-products';
